import { apiClient, refreshSession, setLogin } from './API';

const getExpirationTime = (expiredAt: number) => {
  return new Date(expiredAt * 1000);
};

type LoginResponse = {
  value: LoginResult;
};

export const loginWithEmail = async (email: string, password: string): Promise<LoginResult | undefined> => {
  try {
    const {
      data: { value },
    } = await apiClient.post<LoginResponse>('/login', { email, password });
  
    setLogin(value, getExpirationTime(value.expiredAt));
    refreshSession();
  
    return value;
  } catch(err) {
    console.log(err);
    return;
  }

};

export const register = async (
  email: string,
  password: string,
  referralCode: string | null,
  hcaptchaResponse: string,
) => {
  const {
    data: { value },
  } = await apiClient.post<LoginResponse>(
    '/register',
    {
      email,
      password,
      referralCode,
      hcaptchaResponse,
    },
  );

  setLogin(value, getExpirationTime(value.expiredAt));
  refreshSession();

  return value;
};

export type LoginResult = {
  sessionId: string;
  playfabSessionTicket: string;
  email: string;
  expiredAt: number;
  playfabId: string;
  userId: string;
};
